module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/emailhosting/bravenet_emailhosting_aliasing.png";